var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-breadcrumb"},[_c('ul',_vm._l((_vm.breadcrumbs),function(crumb,index){return _c('li',{key:index},[(crumb.to)?_c('router-link',{attrs:{"to":crumb.to}},[_vm._v(_vm._s(crumb.text))]):_c('span',[_vm._v(_vm._s(crumb.text))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }